import styled from '@emotion/styled';

import { black60, black87, vividPurple, white60 } from '~/styles';

export const StylesWrapper = styled.div`
  .MuiCard-root {
    background: transparent;
    box-shadow: none;
    overflow: visible;
  }

  .MuiCard-root > div {
    background: transparent;
  }

  .MuiCardMedia-root {
    border-radius: 50%;
    :before {
      position: absolute;
      background: ${vividPurple};
      opacity: 0;
      width: 100%;
      height: 100%;
      left: 0px;
      top: 0px;
      border-radius: 100%;
      content: '';
    }
  }
`;

export const TeacherName = styled.div`
  font-size: 20px;
  font-weight: 300;
  line-height: normal;
  letter-spacing: 0.25px;
  text-align: center;
  color: ${black87};
`;

const StyleName = styled.div`
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.33;
  letter-spacing: 0.4px;
  text-align: center;
  color: ${black60};
`;
export const CardContent = styled.div<{ light: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 16px 0 0;
  ${TeacherName} {
    ${({ light }) => light && `color: #fff;`}
  }
  ${StyleName} {
    ${({ light }) => light && `color: ${white60};`}
  }
`;
